import React from "react"
import styled from "styled-components"

const StyledFlex = styled.div`
  min-width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const DetailHeader = ({
  children,
  ...props
}: React.ComponentProps<typeof StyledFlex>) => {
  return <StyledFlex {...props}>{children}</StyledFlex>
}
